{
  "withdrawal": {
    "cancel": "Cancel",
    "headerMessage": "Withdraw your investment",
    "from": "From",
    "portfolio": "Portfolio",
    "withdrawalType": "Withdrawal type",
    "withdrawalTypes": {
      "full": "Full",
      "partial": "Partial"
    },
    "amount": "Amount",
    "withdrawalTypeNotification": "This will be a full withdrawal where all securities will be sold and the funds will be sent to your chosen bank account.",
    "to": "To",
    "schedule": "Schedule",
    "scheduleOptions": {
      "justThisOnce": "Just this once",
      "weekly": "Weekly",
      "biWeekly": "Bi-weekly",
      "monthly": "Monthly"
    },
    "infoModal": {
      "homeBuyersPlanMessage": "To withdraw for the Home Buyers Plan reason, you need to submit additional documents to the government of Canada. To do this please contact support.",
      "lifeLongLearningPlanMessage": "To withdraw for the Lifelong Learning Plan reason, you need to submit additional documents to the government of Canada. To do this please contact support."
    },
    "errorBanner": {
      "title": "Unable to withdraw funds from this account",
      "title2": "Unable to transfer funds from this account",
      "RESPErrorMessage": "To withdraw from an RESP account, you need to submit an <a href=\"https://www.ciinvestmentservices.com/docs/CI%20IS-%20Registered%20Accounts%20RESP%20Withdrawal%20Form%20-E.pdf\" style=\"color: {{link}}\">RESP withdrawal form</a> and proof of enrolment in a post-secondary institution as per the federal rules governing the account. To do this <a href=\"{{linkUrl}}\" style=\"color: {{link}}\">please contact support.</a>",
      "homeBuyersPlanMessage": "To withdraw for the Home Buyers Plan reason, you need to submit the <a href=\"https://www.canada.ca/content/dam/cra-arc/formspubs/pbg/t1036/t1036-21e.pdf\" style=\"color: {{link}}\">HBP withdrawal form.</a> To do this <a href=\"{{linkUrl}}\" style=\"color: {{link}}\">please contact support.</a>",
      "lifeLongLearningPlanMessage": "To withdraw for the Lifelong Learning Plan reason, you need to the <a href=\"https://www.canada.ca/content/dam/cra-arc/formspubs/pbg/rc96/rc96-22e.pdf\" style=\"color: {{link}}\">LLP withdrawal form.</a> To do this <a href=\"{{linkUrl}}\" style=\"color: {{link}}\">please contact support.</a>",
      "lockedInAccountMessage": "To withdraw from a locked-in account or retirement income fund account, you need to submit additional documents as per the pension legislation governing the account. To do this To do this <a href=\"{{linkUrl}}\" style=\"color: {{link}}\">please contact support.</a>",
      "RRIF": "To withdraw from a RRIF you need to set up payment instructions on the account. To do so, view the accounts page or <a href=\"{{linkUrl}}\" style=\"color: {{link}}\">please contact support.</a>",
      "RIF_SPOUSAL": "To withdraw from a Spousal RRIF you need to set up payment instructions on the account. To do so, view the accounts page or <a href=\"{{linkUrl}}\" style=\"color: {{link}}\">please contact support.</a>",
      "internalTransferMessage": "Transferring funds from a locked-in account or retirement income fund account to a different account is permissible under certain conditions outlined by the pension legislation governing the account. To do this <a href=\"{{linkUrl}}\" style=\"color: {{link}}\">please contact support.</a>"
    },
    "withdrawalReason": "Withdrawal reason",
    "withdrawalReasonOptions": {
      "COMPLETED_MY_GOAL": "Completed my goal",
      "DISSATISFIED_WITH_ONEVEST": "I am not happy with the application",
      "INVESTING_IS_NOT_FOR_ME": "Investing is not for me",
      "POOR_RETURNS": "Poor returns",
      "HOME_BUYERS_PLAN": "Home buyers plan",
      "LIFELONG_LEARNING_PLAN": "Lifelong learning plan",
      "OTHER": "Other"
    },
    "confirmWithdrawal": "Confirm withdrawal",
    "starting": "Starting",
    "startingOptions": {
      "now": "Now",
      "futureDate": "Future Date"
    },
    "portfolioWithdrawalDetailsModal": {
      "portfolioBalance": "Portfolio Balance",
      "portfolioBalanceInfo": "This is the total of all the funds that your portfolio is currently holding.",
      "amountOnHold": "Amount on hold",
      "amountOnHoldInfo": "Deposits have a 5 business-day hold before you can withdraw these funds. We apply this hold for risk management purposes. You are also unable to withdraw cash currently reserved for other funds transfers and fees.",
      "availableToWithdraw": "Available to withdraw",
      "availableToWithdrawInfo": "This is how much money you have available in your Personal account to withdraw right now. It includes unused cash from your deposits, dividends you've earned, plus any proceeds from stocks or ETFs you've sold"
    },
    "withdrawalBreakDown": {
      "loadingMessage": "Fetching...",
      "availableToWithdraw": "Available to withdraw",
      "withdrawalAmount": "Withdrawal amount",
      "feesAndTaxTypes": {
        "DEREGISTRATION": "Deregistration Fee",
        "DEREGISTRATION_TAX": "Deregistration Tax",
        "WITHHOLDING_TAX": "Withholding Tax"
      },
      "estimatedWithdrawalAmount": "Estimated withdrawal amount",
      "estimatedNetWithdrawalAmount": "Estimated net withdrawal amount",
      "federalTaxWithheld": "Federal taxes withheld",
      "stateTaxWithheld": "State taxes withheld",
      "feesChargedFromCad": "Fees will be charged from your CAD balance",
      "feesDeductedSeparately": "{{amount}} {{currency}} in fees will be deducted separately from your CAD balance",
      "partialFeeCoveredFromCad": "{{feeType}} ({{amount}}) will be deducted from your CAD balance as there is sufficient CAD available.",
      "partialFeesCoveredFromCad": "{{count}} fees will be deducted from your CAD balance as there is sufficient CAD available. Remaining fees will be deducted from your withdrawal amount.",
      "fxRateUnavailable": "Fees cannot be displayed. Exchange rate is currently unavailable.",
      "netFeesUnavailable": "The net amount could not be calculated. Try again or switch to Gross.",
      "netExceedsAvailable": "The net amount plus withholding tax exceeds the amount available to withdraw. Enter a lower net amount or switch to Gross."
    },
    "illiqudWithdrawalInfo": {
      "caption": "Withdrawal from illiquid investment",
      "text": "This portfolio contains illiquid investment(s) which do not trade every day, nor have an exact known market value at the time of sale. As a result, we are estimating that your withdrawal amount will likely fall into a range of +/-5% of the amount you have specified. This withdrawal amount is not guaranteed and may fall outside of the estimated ranges we provided, depending on current market conditions."
    },
    "withdrawErrorHeader": "Unable to withdraw funds from this account",
    "withdrawRrspAccountLlpPlanError": "To withdraw funds from your RRSP for the Lifelong Learning Plan reason, you will need to submit the <0>LLP withdrawal form</0>. For assistance, <1>please contact support</1>.",
    "withdrawRrspAccountHbpPlanError": "To withdraw funds from your RRSP for the Home Buyers Plan, you will need to submit the <0>HBP withdrawal form</0>. For assistance, <1>please contact support</1>.",
    "withdrawRespAccountError": "To withdraw from an RESP account, you need to submit an <0>RESP withdrawal form</0> and proof of enrolment in a post-secondary institution as per the federal rules governing the account. To do this, <1>please contact support</1>.",
    "withdrawLockedInAccountError": "<0>Please contact support</0> to facilitate the transfer of funds from a locked-in account.",
    "withdrawFhsaAccountError": "<0>Please contact support</0> to facilitate the transfer of funds.",
    "withdrawIncomeFundsAccountError": "You need to set up payment instructions at the beginning of each year to withdraw funds from your {{accountType}} account. To do this, <0>please contact support</0>.",
    "prematureWithdrawalMessage": "Based on your age and account type, this may be considered an early withdrawal and could result in penalties or additional taxes. Please contact your advisor if you have questions.",
    "rothIraTaxDisclaimer": "<span><b>Important Tax Information:</b> Withdrawals from Roth IRAs may not be subject to federal or state income tax if they meet IRS qualifications (e.g., account held for 5+ years and you're over age 59½). Withholding is optional, but we recommend consulting with a qualified tax advisor to determine your specific tax situation.</span>",
    "usaTaxDisclaimer": "<span>Our tools can help you manage federal and state tax withholdings for your IRA distributions. Tax laws are complex and subject to change. We do not guarantee the accuracy or completeness of tax details.<br /><br />You are responsible for selecting the correct withholding amounts based on your individual tax situation, and you will be responsible for any under-withholding.<br /><br />For personalized advice, please consult with a qualified tax advisor. By using our withholding tools, you understand that these features are a convenience and do not constitute tax advice.</span>"
  },
  "types": {
    "DEPOSIT": "Deposit",
    "WITHDRAW": "Withdrawal"
  },
  "states": {
    "DRAFT": "Draft",
    "ACTIVE": "Active",
    "CANCELED": "Canceled",
    "FAILED": "Failed",
    "INITIATED": "Initiated",
    "PROCESSING": "Processing",
    "READY": "Ready",
    "RECONCILED": "Reconciled",
    "REQUESTED": "Requested",
    "REVIEWING": "Reviewing",
    "COMPLETED": "Completed",
    "FROZEN": "Frozen",
    "INACTIVE": "Inactive"
  },
  "verifyIdentity": {
    "1": "To start investing, you need to verify your identity. ",
    "2": "Please contact our support team",
    "3": " for assistance."
  },
  "depositEftLockedInAccountError": "<0>Please contact support</0> to facilitate the transfer of funds into a locked-in account.",
  "depositEftIncomeFundsAccountError": "<0>Please contact support</0> to facilitate the transfer of funds into an income fund account.",
  "depositInternalTransferFromAccountError": "You can not transfer funds out of the selected account. <0>Please contact our support team</0> for assistance.",
  "depositInternalTransferToAccountError": "You can not transfer funds into the selected account. <0>Please contact our support team</0> for assistance.",
  "depositFhsaInternalTransferAccountError": "<0>Please contact the support team</0> to facilitate the transfer of funds.",
  "frequencyOption": {
    "ONE_TIME": "One-Time",
    "DAILY": "Daily",
    "WEEKLY": "Weekly",
    "SEMI_MONTHLY": "Semi-Monthly",
    "MONTHLY": "Monthly",
    "BI_WEEKLY": "Bi-Weekly",
    "QUARTERLY": "Quarterly"
  },
  "selectCurrency": "Select Currency",
  "availableCurrencyBalance": "Available {{currency}} Balance:",
  "participantNumber": "Participant/DTC Number",
  "participantNumberLengthError": "Participant/DTC Number must be exactly 4 characters",
  "participantNumberTooltip": "The Participant/DTC number is a unique identifier assigned by The Depository Trust Company (DTC) to financial institutions (brokers, banks, custodians) that participate in the U.S. securities settlement system. It is used to route securities to the correct receiving firm during a transfer. You can look up a firm's DTC number in the [DTC directory](https://www.dtcc.com/client-center/dtc-directories).",
  "pendingTransactionsBar": {
    "caption": {
      "DEPOSIT": "Deposits",
      "WITHDRAW": "Withdrawals"
    },
    "byDirection": "By: Type",
    "byState": "By: State"
  }
}
